import SellerGoodAttention, {
  mapStateToProps,
} from '../../../../../pages/vip/features/seller-good-attention/seller-good-attention-highlighted';

export default SellerGoodAttention;

export { mapStateToProps };
